import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        marginBottom: 12, 
        width: '100%', 
        background: '#1b2039', 
        borderRadius: 4, 
        padding: '10px 0'
    },
    wrap: {
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        width: '100%'
    },
    helper: {
        color: '#fff', 
        fontSize: 18, 
        textTransform: 'uppercase', 
        fontFamily: 'Montserrat, sans-serif'
    }
}))

export {
    useStyles
}